import { render, staticRenderFns } from "./HospClinDoctor.vue?vue&type=template&id=213f1d3c"
import script from "./HospClinDoctor.vue?vue&type=script&lang=js"
export * from "./HospClinDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports